/* eslint-disable react/prop-types */
import React from 'react';
import { Col } from 'antd';

const BadesulDivider = ({ sizeMap }) => (
  <Col {...sizeMap[1]}>
    <hr />
  </Col>
);

export default BadesulDivider;
